import { fabric } from 'fabric'

export const TemplateTextbox = fabric.util.createClass(fabric.Textbox, {
    type: 'template-textbox',

    initialize: function (text, options) {
        options || (options = {})
        this.callSuper('initialize', text, options)
        this.set('name', options.name || undefined) // Should probably throw an error here.
    },

    toString: function () {
        return this.callSuper('toString') + ' (name: ' + this.get('name') + ')'
    },

    toObject: function () {
        return fabric.util.object.extend(this.callSuper('toObject'), {
            name: this.get('name'),
        })
    },
})

fabric.TemplateTextbox = TemplateTextbox
fabric.TemplateTextbox.fromObject = function (object, callback) {
    // NOTE: The 'name' prop should probably be changed to 'text' based on learnings.
    // http://fabricjs.com/fabric-intro-part-3#subclassing (See argument + options type example)
    // http://fabricjs.com/docs/fabric.js.html#line30925
    return fabric.Object._fromObject(
        'TemplateTextbox',
        object,
        callback,
        'name'
    )
}
